import { COMPONENT_SIZES as e, TEXT_HEADLINE_SIZES as t } from "./sizes.js";
//#region common/constants/index.js
var n = {
	CRITICAL: "critical",
	WARNING: "warning",
	POSITIVE: "positive"
}, r = {
	LARGE: "lg",
	EXTRA_LARGE: "xl"
}, i = {
	100: "d-description--xs",
	200: "d-description--sm",
	300: "",
	400: "d-description--lg",
	500: "d-description--xl",
	xs: "d-description--xs",
	sm: "d-description--sm",
	md: "",
	lg: "d-description--lg",
	xl: "d-description--xl"
}, a = {
	100: "d-label--xs",
	200: "d-label--sm",
	300: "",
	400: "d-label--lg",
	500: "d-label--xl",
	xs: "d-label--xs",
	sm: "d-label--sm",
	md: "",
	lg: "d-label--lg",
	xl: "d-label--xl"
}, o = {
	esc: "Esc",
	escape: "Escape",
	tab: "Tab",
	enter: "Enter",
	space: "Space",
	spacebar: "Spacebar",
	up: "Up",
	arrowup: "ArrowUp",
	left: "Left",
	arrowleft: "ArrowLeft",
	right: "Right",
	arrowright: "ArrowRight",
	down: "Down",
	arrowdown: "ArrowDown",
	home: "Home",
	end: "End"
}, s = n.CRITICAL, c = "dt", l = {
	VALIDATION_MESSAGE_TYPES: n,
	DESCRIPTION_SIZE_TYPES: r,
	DEFAULT_VALIDATION_MESSAGE_TYPE: s,
	DEFAULT_PREFIX: "dt"
};
//#endregion
export { e as COMPONENT_SIZES, c as DEFAULT_PREFIX, s as DEFAULT_VALIDATION_MESSAGE_TYPE, i as DESCRIPTION_SIZE_MODIFIERS, r as DESCRIPTION_SIZE_TYPES, o as EVENT_KEYNAMES, a as LABEL_SIZE_MODIFIERS, t as TEXT_HEADLINE_SIZES, n as VALIDATION_MESSAGE_TYPES, l as default };

//# sourceMappingURL=index.js.map